import { Button } from '@components/Button';
import { ErrorMessage, FormField, FormLabel, InputField } from '@components/FormFields';
import Block from '@components/Layout/Block';
import auth from '@util/api/auth/index';
import { useRouter } from 'next/router';
import { FC, useEffect, useState } from 'react';
//styles
import { CreateLoftyLeadDto } from '@engelvoelkersamericas/api';
import { apiClient } from 'api-client';
import { useTranslations } from 'next-intl';
import {
  Container,
  GridLeftContainer,
  GridRightContainer,
  Header,
  ModalButtonWrapper,
  SentMessage,
  StyledForm,
  Text,
} from './styles';

interface NewsletterFormProps {
  header?: string;
  eyebrow?: string;
  header2?: string;
  eyebrow2?: string;
  chimeId?: string;
  chimeType?: string;
}

const NewsletterForm: FC<NewsletterFormProps> = ({
  header,
  eyebrow,
  header2,
  eyebrow2,
  chimeId,
  chimeType,
}) => {
  const t = useTranslations();
  const [isSent, setIsSent] = useState(false);
  const [isSuccess, setIsSuccess] = useState<boolean | null>(null);
  const [emailError, setEmailError] = useState('');
  const [firstNameError, setFirstNameError] = useState('');
  const [lastNameError, setLastNameError] = useState('');
  const [url, setURL] = useState('');

  const router = useRouter();
  useEffect(() => {
    setURL(`${window.location.origin}${router.asPath}`);
  }, []);

  const sendForm = () => {
    setIsSent(true);
  };

  const handleInputChange = (e) => {
    if (e?.target?.id == 'firstName') {
      setFirstNameError('');
    }

    if (e?.target?.id == 'lastName') {
      setLastNameError('');
    }

    if (e?.target?.id == 'email') {
      setEmailError('');
    }
  };

  const handleSubmit = async (event) => {
    // Stop the form from submitting and refreshing the page.
    event.preventDefault();
    setEmailError('');
    setFirstNameError('');
    setLastNameError('');
    setEmailError('');

    //get the form data
    const data = {
      firstName: event?.target?.firstName?.value,
      lastName: event?.target?.lastName?.value,
      email: event?.target?.email?.value,
    };

    //validations
    let formIsValid = true;
    setFirstNameError('');
    if (!data.firstName) {
      formIsValid = false;
      setFirstNameError(t('Validation.firstNameRequired'));
    }

    if (!data.email) {
      formIsValid = false;
      setEmailError(t('Email cannot be empty'));
    }

    if (typeof data.email !== 'undefined') {
      let lastAtPos = data.email.lastIndexOf('@');
      let lastDotPos = data.email.lastIndexOf('.');

      if (
        !(
          lastAtPos < lastDotPos &&
          lastAtPos > 0 &&
          data.email.indexOf('@@') == -1 &&
          lastDotPos > 2 &&
          data.email.length - lastDotPos > 2
        )
      ) {
        formIsValid = false;
        setEmailError(t('Email is not valid'));
      }
    }

    if (formIsValid) {
      const chimeObj: CreateLoftyLeadDto = {
        userFirstName: data.firstName,
        userLastName: data.lastName,
        userEmail: data.email,
        chimeId: chimeId ? parseInt(chimeId, 10) : undefined,
        type: chimeType as 'Shop' | 'Agent' | 'EV Global',
      };
      if (url) {
        chimeObj.url = url;
      }
      // Get session user data
      const user = await auth.getUser();
      // Update payload data
      if (user) {
        user?.attributes?.phone_number && (chimeObj.userPhone = user?.attributes?.phone_number);
      }
      if (window.location.href) {
        chimeObj.url = window.location.href;
      }
      const results = await apiClient.createLoftyLeads({
        createLoftyLeadDto: chimeObj,
      });
      sendForm();
      setIsSuccess(results ? true : false);

      //For better debugging
      console.log('Data sent: ', chimeObj);
      console.log('Results: ', results);
    }
  };
  return (
    <Block fullOnMobile backgroundInner="secondaryBg">
      <Container $isSent={isSent}>
        {isSent && isSuccess !== undefined ? (
          <SentMessage $isSent={isSent}>
            {header2 && <Header>{header2}</Header>}
            {eyebrow2 && <Text>{eyebrow2}</Text>}
          </SentMessage>
        ) : (
          <>
            <GridLeftContainer $isSent={isSent}>
              {header && <Header>{header}</Header>}
              {eyebrow && <Text>{eyebrow}</Text>}
            </GridLeftContainer>
            <GridRightContainer $isSent={isSent}>
              <StyledForm onSubmit={handleSubmit}>
                <FormField>
                  <FormLabel htmlFor="firstName">{t('First Name')}</FormLabel>
                  <InputField
                    id="firstName"
                    placeholder={t('First Name')}
                    type="text"
                    $isError={firstNameError != '' ? true : false}
                    onChange={(e) => handleInputChange(e)}
                  />
                  {firstNameError != '' && <ErrorMessage message={firstNameError} />}
                </FormField>

                <FormField>
                  <FormLabel htmlFor="lastName">{t('Last Name')}</FormLabel>
                  <InputField
                    id="lastName"
                    placeholder={t('Last Name')}
                    $isError={lastNameError != '' ? true : false}
                    onChange={(e) => handleInputChange(e)}
                  />
                  {lastNameError != '' && <ErrorMessage message={lastNameError} />}
                </FormField>
                <FormField>
                  <FormLabel htmlFor="email">{t('Email')}</FormLabel>
                  <InputField
                    id="email"
                    name="email"
                    placeholder={'you@emailaddress.com'}
                    onChange={(e) => handleInputChange(e)}
                  />
                  {emailError != '' && <ErrorMessage message={emailError} />}
                </FormField>
                <ModalButtonWrapper>
                  <Button type="submit" variant="primaryRed" label={t('Sign Up')} arrow={false} />
                </ModalButtonWrapper>
              </StyledForm>
            </GridRightContainer>
          </>
        )}
      </Container>
    </Block>
  );
};
export default NewsletterForm;
